export enum LocalStorageNames {
  HeroCarouselItem = "Application.model.HeroCarouselItem",
  SettingsModel = "Application.model.SettingsModel",
  AboutModel = "Application.model.AboutModel",
};
